<template>
  <v-container class="session fill-height" fluid>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="6">
        <div class="text-center pa-8">
          <img
            :src="'data:image/png;base64,' + $store.state.client.client.logo"
            alt="Themis"
            width="200px"
          />
        </div>
        <v-sheet class="session-form pa-8" elevation="10">
          <h2 class="mb-4 primary--text">
            {{ $t("login.title") }}
          </h2>
          <p class="black--text">
            {{ $t("login.login_info") }}
          </p>

          <v-form @submit="onLogin" ref="loginForm" align-center justify-center>
            <v-text-field
              prepend-icon="person"
              name="email"
              :label="$t('login.email')"
              type="text"
              v-model="login.email"
            ></v-text-field>
            <!--v-text-field
                  id="password"
                  prepend-icon="lock"
                  name="password"
                  :label="$t('login.password')"
                  v-model="login.password"
                  type="password"
                ></v-text-field-->
            <v-btn
              type="submit"
              large
              block
              color="primary"
              :loading="loading"
              :disabled="loading"
              >{{ $t("login.send_code") }}</v-btn
            >
          </v-form>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex"
import { AUTH_REQUEST, TOKEN_REQUEST } from "@/store/actions/auth"
import { GET_LOGO } from "@/store/actions/client"

export default {
  data() {
    return {
      loading: false,
      askCode: false,
      login: {},
      code: null,
    }
  },
  mounted() {
    this.GET_LOGO({ url: location.protocol + "//" + location.host })
    if (this.$route.query.token !== undefined) {
      this.onSubmit(this.$route.query.token)
    }
  },
  methods: {
    ...mapActions("auth", [AUTH_REQUEST, TOKEN_REQUEST]),
    ...mapActions("client", [GET_LOGO]),
    onLogin: function (e) {
      e.preventDefault()
      if (!this.$refs.loginForm.validate()) {
        console.log("Not valid...")
        return
      }

      const self = this
      this.loading = true
      this.TOKEN_REQUEST(
        Object.assign(this.login, {
          url: location.protocol + "//" + location.host,
        })
      ).then(
        () => {
          self.loading = false
          self.$toast.success(this.$t("login.email_send"))
          this.$router.push("/code")
        },
        () => {
          self.loading = false
        }
      )
    },
  },
}
</script>
<style lang="scss">
.session {
  background-image: radial-gradient(
    circle farthest-corner at -4% -12.9%,
    rgb(86, 185, 231) 0.3%,
    rgb(28, 45, 134) 90.2%
  );

  .session-form {
    background: rgb(255, 255, 255);
  }
}
.logo {
  display: block;
  font-size: 0;
}
</style>
